import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { UserAddOutlined } from "@ant-design/icons";
import { message } from "antd";
import { UserContext } from "../contexts/UserContext";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const antIcon = (
  <LoadingOutlined style={{ fontSize: 15, color: "white" }} spin />
);

const Register = () => {
  const { register } = useContext(UserContext);
  const [load, setLoad] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [invite, setInvite] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [errMessage, setErrMessage] = useState("");

  const key = "successRegister";
  const onSuccessMessage = () => {
    message.loading({ content: "Loading...", key });
    setTimeout(() => {
      message.success({
        content: "Registered Successfully.",
        key,
        duration: 2,
      });
    }, 700);
  };

  const handleSubmit = (e) => {
    setLoad(true);
    if (invite !== "warunsinx") {
      setLoad(false);
      return;
    }
    const regData = { email, password, firstName, lastName };
    register(regData)
      .then(() => {
        setTimeout(() => {
          onSuccessMessage();
        }, 300);
      })
      .catch((err) => {
        setErrMessage(err);
        setLoad(false);
      });
    e.preventDefault();
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center">
      <div className="w-full max-w-xs my-8 sm:max-w-sm sm:my-0">
        <div className="flex items-start justify-end mb-5 text-blue-500">
          <p className="text-2xl text-center m-0 p-0">
            Join <span className="font-bold">MEMMiFシ</span>
          </p>
          <UserAddOutlined className="text-4xl mx-5" />
        </div>
        <form
          className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-5"
          onSubmit={handleSubmit}
        >
          <div className="flex flex-wrap -mx-3">
            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-first-name"
              >
                First Name
              </label>
              <input
                required
                pattern="[^'\x22]+"
                maxLength="19"
                className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:shadow-outline"
                id="grid-first-name"
                type="text"
                placeholder="Steve"
                value={firstName}
                onChange={(e) =>
                  setFirstName(e.target.value.replace(/\\/g, "Stupid"))
                }
              />
            </div>
            <div className="w-full md:w-1/2 px-3">
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-last-name"
              >
                Last Name
              </label>
              <input
                required
                pattern="[^'\x22]+"
                maxLength="19"
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:shadow-outline"
                id="grid-last-name"
                type="text"
                placeholder="Jobs"
                value={lastName}
                onChange={(e) =>
                  setLastName(e.target.value.replace(/\\/g, "Stupid"))
                }
              />
            </div>
          </div>
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-full px-3 mt-8 mb-4 md:my-3">
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-email"
              >
                Email
              </label>
              <input
                required
                maxLength="39"
                className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:shadow-outline ${
                  errMessage ? "border-red-500" : ""
                }`}
                id="grid-email"
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {errMessage ? (
                <p className="text-red-500 text-xs italic">{errMessage}</p>
              ) : (
                <p className="text-gray-600 text-xs italic">
                  We'll never share your email with anyone.
                </p>
              )}
            </div>
            <div className="w-full px-3">
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-password"
              >
                Password
              </label>
              <input
                required
                minLength="5"
                maxLength="30"
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:shadow-outline"
                id="grid-password"
                type="password"
                placeholder="Make it as crazy as you'd like"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="w-full px-3 mt-3">
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-invite"
              >
                Invite Code
              </label>
              <input
                required
                minLength="5"
                maxLength="30"
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:shadow-outline"
                id="grid-invite"
                type="password"
                placeholder="Enter your invite code"
                value={invite}
                onChange={(e) => setInvite(e.target.value)}
              />
            </div>
          </div>
          <p className="text-xs italic text-gray-600 m-0 p-0 mb-8" to="/login">
            By clicking register you agree to our{" "}
            <span
              onClick={() =>
                window.open(
                  "https://www.termsfeed.com/live/a2a26229-27b1-4c6d-afed-0c912bee6890",
                  "_blank"
                )
              }
              className="text-blue-500 cursor-pointer hover:text-blue-700 font-bold"
            >
              PDPA
            </span>
          </p>
          <div className="flex items-center justify-between">
            <Link
              className="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800"
              to="/login"
            >
              Have an account ?
            </Link>
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline flex items-center justify-center w-24 h-10"
              type="submit"
              disabled={load}
            >
              {load ? (
                <Spin indicator={antIcon} />
              ) : (
                <p className="m-0 p-0">REGISTER</p>
              )}
            </button>
          </div>
        </form>
        <p className="text-center text-gray-500 text-xs">
          &copy;2020 Memmify. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Register;
